var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { AuthService } from './auth.service';
var ApiService = /** @class */ (function () {
    function ApiService(http, authService) {
        this.authService = authService;
        this.headers = {
            'Accept': 'html/text',
            'Content-Type': 'text/plain;charset=UTF-8'
            // 'Access-Control-Allow-Headers': 'Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers',
            // 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS'
        };
        this.headers2 = {
            'Accept': 'html/text',
            'Content-Type': 'application/x-www-form-urlencoded'
            // 'Access-Control-Allow-Headers': 'Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers',
            // 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS'
        };
        this.http = http;
    }
    ApiService.prototype.post = function (data, path, isSecure) {
        var _this = this;
        var headers = __assign({}, this.headers2);
        var searchParams = Object.keys(data).map(function (key) {
            return encodeURIComponent(key) + '=' + encodeURIComponent(data[key]);
        }).join('&');
        return new Promise(function (resolve, reject) {
            _this.http.post(environment.api + "/" + path, searchParams, {
                headers: new HttpHeaders({
                    'Accept': 'html/text',
                    'Content-Type': 'application/x-www-form-urlencoded'
                    // 'Access-Control-Allow-Headers': 'Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers',
                    // 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS'
                })
            }).toPromise()
                .then(function (response) {
                return resolve(response);
            })
                .catch(function (error) {
                return reject(error);
            });
        });
    };
    ApiService.prototype.get = function (path, isSecure) {
        var _this = this;
        var headers = __assign({}, this.headers2);
        /**
         *
         *
            res.setHeader('Access-Control-Allow-Origin', 'http://localhost:8888');
        
            // Request methods you wish to allow
            res.setHeader('Access-Control-Allow-Methods', 'GET, POST, OPTIONS, PUT, PATCH, DELETE');
        
            // Request headers you wish to allow
            res.setHeader('Access-Control-Allow-Headers', 'X-Requested-With,content-type');
        
            // Set to true if you need the website to include cookies in the requests sent
            // to the API (e.g. in case you use sessions)
            res.setHeader('Access-Control-Allow-Credentials', true);
        
         *
         */
        return new Promise(function (resolve, reject) {
            _this.http.get(environment.api + "/" + path, {
                headers: new HttpHeaders({
                    'Accept': 'html/text',
                    'Content-Type': 'application/x-www-form-urlencoded'
                    // 'Access-Control-Allow-Headers': 'Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers',
                    // 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS'
                })
            }).toPromise()
                .then(function (response) {
                return resolve(response);
            })
                .catch(function (error) {
                return reject(error);
            });
        });
    };
    ApiService.prototype.get2 = function (path, isSecure) {
        var _this = this;
        var headers = __assign({}, this.headers2);
        return new Promise(function (resolve, reject) {
            _this.http.get("" + path, {
                headers: new HttpHeaders({
                    'Accept': 'html/text',
                    'Content-Type': 'application/x-www-form-urlencoded'
                    // 'Access-Control-Allow-Headers': 'Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers',
                    // 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS'
                })
            }).toPromise()
                .then(function (response) {
                return resolve(response);
            })
                .catch(function (error) {
                return reject(error);
            });
        });
    };
    return ApiService;
}());
export { ApiService };
